export const SET_USER = 'setUser';
export const SET_WEBSOCKET = 'set_websocket';
export const SET_WEBSOCKET_CLIENT_ID = 'set_websocket_client_id';
